export default class NotifierMessageError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ValidationError";
  }
}
